import { render, staticRenderFns } from "./sharedVenueList.vue?vue&type=template&id=3515833b&scoped=true&"
import script from "./sharedVenueList.vue?vue&type=script&lang=js&"
export * from "./sharedVenueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3515833b",
  null
  
)

export default component.exports